import { Component } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { AuthService } from '../../providers/auth-service';
import { LoginPage } from '../login/login';
import { VerMapaPage } from '../vermapa/vermapa';

declare var gtag;

@Component({
	selector: 'cadastro',
  	templateUrl: 'cadastro.html',
})

export class CadastroPage {
	public loginPage = LoginPage;

  public cadastroFB = {
    nome: "",
		email: "",
		senha: ""
	};
	
	public cadastroGoogle = {
    nome: "",
		email: "",
		senha: ""
  };

  public cadastro = {
    nome: "",
    email: ""
  };

	createSuccess = false;
  registerCredentials = { email: null, nome: null, senha: null };

	constructor(private nav: NavController, public navParams: NavParams, private auth: AuthService, 
							private alertCtrl: AlertController) {

		if(navParams.get("origem") === "facebook"){
			this.cadastroFB = {
				nome: navParams.get("nome"),
				email: navParams.get("email"),
				senha: ""
			}

			this.registerCredentials = this.cadastroFB;
			this.cadastro = this.cadastroFB;

		} else if(navParams.get("origem") === "google"){
			this.cadastroGoogle = {
				nome: navParams.get("nome"),
				email: navParams.get("email"),
				senha: ""
			}

			this.registerCredentials = this.cadastroGoogle;
			this.cadastro = this.cadastroGoogle;
		}
  }

  ionViewWillEnter(){
    var sexo = document.getElementById("sexo") as HTMLSelectElement;
    sexo.selectedIndex = 0;
  }

	public cadastrar() {
    	document.getElementById("botao-cadastro").setAttribute("disabled", "disabled");
      this.auth.cadastrar(this.registerCredentials).subscribe(success => {
      		if (success) {
						gtag('event', 'cadastro');
        		this.createSuccess = true;
        		this.showPopup("Conta criada com sucesso!", "Seja bem vindo!");
        		this.nav.push(VerMapaPage);
	      	} else {
	        	this.showPopup("Por favor, tente novamente!", "Houve um problema em criar sua conta.");
					}
					document.getElementById("botao-cadastro").removeAttribute("disabled");
	    },
      	error => {
					this.showPopup("Error", error);
					document.getElementById("botao-cadastro").removeAttribute("disabled");
				}
			);
			
 	}
 
  	showPopup(title, text) {
    	let alert = this.alertCtrl.create({
      		title: title,
      		subTitle: text,
      		buttons: [{
          		text: 'OK',
          		handler: data => {
	            	
	          	}
        	}]
   		});

		alert.present();
  	}
}


// WEBPACK FOOTER //
// ./src/pages/cadastro/cadastro.ts